import "./DatePickerComponent.scss";
import template from "./DatePickerComponent.html";
import {IComponentOptions, IOnChanges, IOnChangesObject, ITemplateCacheService} from "angular";
import {IDatepickerConfig} from "angular-ui-bootstrap";
import {ComponentCallback} from "../../types/AngularJS";
import {DatePickerDefaults, DefaultDateFormat} from "./DatePickerDefaults";
import {ObjectUtil} from "../../js/util/ObjectUtil";
import {DATE_PICKER_POPUP_TEMPLATE_NAME, DATE_PICKER_POPUP_TEMPLATE} from "./DatePickerPopupCustomTemplate";
import moment = require("moment");

export const DatePicker = "tfDatePicker";

export function datePicker(): IComponentOptions {
    return {
        template,
        bindings: {
            date: "<",
            format: "<",
            options: "<",
            attachToBody: "<",
            minDate: "<",
            maxDate: "<",
            popupClass: "<",
            required: "<",
            disabled: "<",
            onChange: "&"
        },
        controllerAs: "ctrl",
        controller: DatePickerComponentController
    };
}

export class DatePickerComponentController implements IOnChanges {

    public date: string;
    public format: string | null;
    public options: IDatepickerConfig;
    public attachToBody: boolean | null;
    public minDate: Date| null;
    public maxDate: Date | null;
    public required: boolean | null;
    public disabled: boolean | null;
    public onChange: ComponentCallback;
    public popupClass: string | null;

    public selectedDate: Date | null;
    public pickerOptions: IDatepickerConfig;
    public isOpen = false;

    public templatePopupName = DATE_PICKER_POPUP_TEMPLATE_NAME;

    /** @ngInject */
    public constructor(private $templateCache: ITemplateCacheService) {

    }

    public $onChanges(changes: IOnChangesObject): void {
        if (changes.date != null) {
            this.updateSelected(changes.date.currentValue);
        }
        if (changes.options != null || changes.minDate != null || changes.maxDate != null) {
            this.createTemplate();
            this.pickerOptions = this.mergeOptions(this.options);
        }
    }

    private createTemplate() {
        const t = $(DATE_PICKER_POPUP_TEMPLATE);
        if (this.popupClass != null) {
            t.addClass(this.popupClass);
            this.templatePopupName = `tf-custom-popup-datepicker/${this.popupClass}.html`;
            this.$templateCache.put(this.templatePopupName, t[0].outerHTML);
        }
    }

    private updateSelected(newDate: string | null) {
        if (newDate == null) {
            this.selectedDate = null;
        } else if (this.selectedDate == null) {
            this.selectedDate = moment(newDate).toDate();
        } else {
            const current = moment(this.selectedDate);
            const updated = moment(newDate);
            if (!current.isSame(updated)) {
                this.selectedDate = updated.toDate();
            }
        }
    }

    private mergeOptions(options: IDatepickerConfig): IDatepickerConfig {
        const defaultOptions = ObjectUtil.copy(DatePickerDefaults);
        const dateOptions = {
            minDate: this.minDate,
            maxDate: this.maxDate,
        };

        return ObjectUtil.merge({}, defaultOptions, dateOptions, options);
    }

    public get dateFormat(): string {
        if (this.format == null) {
            return DefaultDateFormat;
        } else {
            return this.format;
        }
    }

    public toggle() {
        this.isOpen = !this.isOpen;
    }

    public dateSelected() {
        if (this.selectedDate == null) {
            this.onChange({ date: null });
        } else {
            const updated = moment(this.selectedDate);
            this.onChange({ date: updated.format("YYYY-MM-DD") });
        }
    }
}
